import { useMemo, useState } from 'react'
import {
  getCompaniesToAssocWithGroup,
  saveAssocCompanyGroup,
} from '../../../../../services/api/https/system/system.http'
import { errorHandler } from '../../../../../services/util/error.service'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  GET_COMPANIES: 'Adquirindo companhias',
  SAVE_ASSOC: 'Salvando associação',
  SUCCESS: 'Associação salva com sucesso',
}

const INITIAL_STATE = {
  company_group: {
    id: 0,
    name: '',
    companies: [],
  },
  companies: [],
  updatedCompanyGroup: {},
  globalFilter: '',
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
}

export default function useModalAssocCompanies() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    //Helpers

    return {
      //Actions
      resetState() {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.NONE,
          errorMessage: null,
        }))
      },

      getCompaniesToAssoc() {
        getCompaniesToAssocWithGroup()
          .then(companies =>
            setState(prevState => {
              prevState.companies = companies.map(c => ({ ...c, selected: false }))
              const assocIds = prevState.company_group.companies.map(c => c.company_id)
              prevState.companies = companies.map(c => ({
                ...c,
                selected: assocIds.includes(c.company_id) ? true : false,
              }))
              prevState.loadingMessage = LOAD_MESSAGE.NONE
              return { ...prevState }
            }),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },

      saveAssocCompanyGroup(companyGroup, companies) {
        companyGroup.companies = companies
          .filter(c => c.selected)
          .map(c => ({ company_id: c.company_id, company_name: c.company_name }))
        saveAssocCompanyGroup(companyGroup)
          .then(companyGroup =>
            setState(prevState => ({
              ...prevState,
              updatedCompanyGroup: companyGroup,
              loadingMessage: LOAD_MESSAGE.SUCCESS,
            })),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },

      //Events

      onGlobalFilterChange(value) {
        setState(prevState => ({ ...prevState, globalFilter: value }))
      },

      onInit(data) {
        if (data)
          setState(prevState => ({
            ...prevState,
            company_group: data,
            loadingMessage: LOAD_MESSAGE.GET_COMPANIES,
          }))
        else
          setState(prevState => ({
            ...prevState,
            company_group: { ...INITIAL_STATE.company_group },
            loadingMessage: LOAD_MESSAGE.GET_COMPANIES,
          }))
      },

      onCheckboxChange(value) {
        setState(prevState => {
          const index = prevState.companies.findIndex(c => c.company_id === value.company_id)
          prevState.companies[index].selected = !prevState.companies[index].selected
          return { ...prevState }
        })
      },

      onBtnSalvarClick(companies) {
        if (companies.filter(c => c.selected) === 0)
          setState(prevState => ({
            ...prevState,
            errorMessage: 'É necessario selecionar pelo menos um item para associar',
          }))
        else setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.SAVE_ASSOC }))
      },
    }
  }, [])

  return { state, localDispatch }
}
